import { Controller } from "@hotwired/stimulus"
import { max } from "moment/moment"

export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    latestReadings: Object, // array of Reading.data JSONs
    fieldName: String,
    fieldUnit: String,
    displacementType: String,
  }

  connect() {
    this.displacementType = this.displacementTypeValue || "horizontal"

    if (this.displacementTypeValue === "vertical") {
      this.renderVerticalDisplacementChart(this.latestReadingsValue)
    } else {
      this.renderHorizontalDisplacementChart(this.latestReadingsValue)
    }
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  renderHorizontalDisplacementChart(data) {
    if (this.displacementType !== "horizontal") {
      return
    }

    const chartData = {
      labels: data.labels,
      datasets: data.datasets,
    }

    const config = {
      type: "line",
      data: chartData,
      options: {
        responsive: true,
        indexAxis: "y",
        stacked: false,
        plugins: {
          legend: { display: false },
          title: {
            display: false,
          },
        },
        scales: {
          y: {
            type: "linear",
            display: true,
            position: "left",
            // 🚀 Force ticks to use your array
            // afterBuildTicks: (axis) => {
            //   axis.ticks = data.labels.map((v) => ({ value: v }))
            //   return axis.ticks
            // },
            // ticks: {
            //   callback: (value) => value, // show the exact number
            //   // maxTicksLimit: 10,
            // },
          },
          x: {
            ticks: { stepSize: 10 },
          },
          y1: {
            type: "linear",
            display: false,
            position: "right",

            // grid line settings
            grid: {
              drawOnChartArea: false, // only want the grid lines for one axis to show up
            },
          },
        },
      },
    }

    const ctx = this.canvasTarget.getContext("2d")
    this.chart = new Chart(ctx, config)
  }

  renderVerticalDisplacementChart(data) {
    const ctx = this.canvasTarget.getContext("2d")

    const chartData = {
      labels: data.labels,
      datasets: data.datasets,
    }

    const config = {
      type: "line",
      data: chartData,
      options: {
        responsive: true,
        indexAxis: "x",
        stacked: false,
        plugins: {
          legend: { display: false },
          title: {
            display: false,
          },
        },
        scales: {
          y: {
            type: "linear",
            display: true,
            position: "left",
          },
          x: {
            display: false,
          },
        },
      },
    }
    this.chart = new Chart(ctx, config)
  }
}
